module.exports = __webpack_public_path__ + "static/media/market.10c02019.svg";